import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=3797cd4a&scoped=true&"
import script from "./UserMessage.vue?vue&type=script&lang=js&"
export * from "./UserMessage.vue?vue&type=script&lang=js&"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=3797cd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797cd4a",
  null
  
)

export default component.exports